import React from 'react' // eslint-disable-line no-unused-vars
const NoAccessTET = () =>
  <div className='row widget-mb-0-row'>
    <div className='col'>
      <div className='container'>
        <div>
          <div className='row'>
            <div className='col-12 col-xl-12'>
              <h3 className='mb-3'>
                <i className='sli-shield m-r-10' />No Access
              </h3>
              <p>Currently access to the Temperature Excursion Tool is unavailable due to technical issues. Access is expected to be reinstated in the coming weeks. If you have a question regarding product stability, you may use the Submit Inquiry or Ask us a question form available on this site to provide the temperature and duration of the excursion or call our US Contact Center at (844) 663-3742 to discuss the details.</p>
            </div>
            <div className='col-xl-2 col-lg-4'>
              <a className='btn btn-primary m-r-10 btn-icon' data-tag='track-link' data-analytics-text='Home' href='/'>
                <i className='sli-action-undo' />Return to the Homepage
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
export default NoAccessTET



// WEBPACK FOOTER //
// ./src/mi-app/NoAccessTET.js